import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from './useAuth';

type ApprovalStatus = 'pending' | 'approved' | 'rejected' | 'suspended' | null;

export function useApproval() {
  const { user } = useAuth();
  const [status, setStatus] = useState<ApprovalStatus>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setStatus(null);
      setLoading(false);
      return;
    }

    supabase
      .from('profiles')
      .select('approval_status')
      .eq('id', user.id)
      .maybeSingle()
      .then(({ data, error }) => {
        if (error) {
          console.error('Error fetching approval status:', error);
          setStatus('pending');
        } else {
          setStatus((data?.approval_status as ApprovalStatus) || 'pending');
        }
        setLoading(false);
      });
  }, [user]);

  return {
    isApproved: status === 'approved',
    isRejected: status === 'rejected' || status === 'suspended',
    isPending: status === 'pending',
    status,
    loading,
  };
}
